import { inject, injectable } from 'inversify';
import OrdersRepository from 'src/features/orders/data/OrdersRepository';
import { CreateOrderParams } from 'features/orders/data/service/OrdersService.types.ts';
import { PaymentMethodSlug } from 'src/types/common';

export interface CreateBankTransferOrderUseCaseParams
  extends Omit<CreateOrderParams, 'payment_method'> {}

@injectable()
class CreateBankTransferOrderUseCase {
  @inject(OrdersRepository) private ordersRepository!: OrdersRepository;

  async execute(params: CreateBankTransferOrderUseCaseParams) {
    return await this.ordersRepository.createOrder({
      ...params,
      payment_method: PaymentMethodSlug.BankTransfer,
    });
  }
}

export default CreateBankTransferOrderUseCase;
